// extracted by mini-css-extract-plugin
module.exports = {"reviewDataWrapper":"ReviewDataButtonBlock_reviewDataWrapper__3Ps02"};